module.exports = __webpack_public_path__ + "static/media/community-dark.53f8e6d7.svg";